import { render } from "./SecuritiesFees.vue?vue&type=template&id=44f1e44f&scoped=true&ts=true"
import script from "./SecuritiesFees.vue?vue&type=script&lang=ts"
export * from "./SecuritiesFees.vue?vue&type=script&lang=ts"

import "./SecuritiesFees.vue?vue&type=style&index=0&id=44f1e44f&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f1e44f"]])

export default __exports__